import React, { useEffect, useState } from "react"
import { Col, Button } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import "flatpickr/dist/themes/material_blue.css"
import FlatPickr from "react-flatpickr"
import { Link } from "react-router-dom"
import { getBillingReceiptList, getCompanyFilterForReceipt, getCompanyLocationFilterForReceipt, getCustomerFilterForReceipt, getFinancialYearFilterForReceipt, getProjectFilterForReceipt } from "store/actions"
import { downloadReceiptExcel } from "helpers/fakebackend_helper"

const JobListGlobalFilter = ({ setGlobalFilter }) => {
  const billingRegisterState = state => state.billing.receiptList.data
  const billingRegisterList = useSelector(billingRegisterState) || []
  const billingCompanyState = state => state.billing.companyFilterForReceipt.companies
  const billingCompanyList = useSelector(billingCompanyState) || []
  const CustomerState = state => state.billing.customerFilterForReceipt.customers
  const customerList = useSelector(CustomerState) || []
  const projectstate = state => state.billing.projectFilterForReceipt.project_name
  const projectList = useSelector(projectstate) || []
  const financialYearState = state => state.billing.financialYearFilterForReceipt.financial_year
  const financialYearList = useSelector(financialYearState) || []
  const locationListState = state => state.billing.locationFilterForReceipt.location
  const locationList = useSelector(locationListState) || [] 



  const [user, setUser] = useState(JSON.parse(localStorage.getItem("authUser")))
  const [status, setStatus] = useState("")
  const [project, setProject] = useState("")
  const [company, setCompany] = useState("")
  const [companyLocation, setCompanyLocation] = useState("")
  const [customer, setCustomer] = useState("")
  const [financialYear, setFinancialYear] = useState("")
  const dispatch = useDispatch()

  const handleSelectProject = ele => {
    const value = ele.value
    setProject(value)
  }
  const handleSelectCompany = ele => {
    const value = ele.value
    setCompany(value)
  }
  const handleSelectCompanyLocation = ele => {
    const value = ele.value
    setCompanyLocation(value)
  }

  const handleSelectCustomer = ele => {
    const value = ele.value
    setCustomer(value)
  }

  const handleFinancialYear = ele => {
    const value = ele.value
    setFinancialYear(value)
  }
  const handleSearch = () => {
    const value = {
      company: company,
      location: companyLocation,
      project: project,
      customer: customer,
      financial_year: financialYear,
      user_id: user.user_id,
    }
    dispatch(getBillingReceiptList(value))
  }

  const handleExport = async () => {
    const value = {
      type: "Receipt",
      company: company,
      location: companyLocation,
      project: project,
      customer: customer,
      financial_year: financialYear,
      user_id: user.user_id,
    }

    const downloadUrl = await downloadReceiptExcel(value)
  }

  useEffect(()=>{
    if(user){
    dispatch(getCompanyFilterForReceipt(user.user_id))
    dispatch(getCompanyLocationFilterForReceipt(user.user_id))
    dispatch(getCustomerFilterForReceipt(user.user_id))
    dispatch(getProjectFilterForReceipt(user.user_id))
    dispatch(getFinancialYearFilterForReceipt(user.user_id))
    }
  },[user])

  return (
    <React.Fragment>
      <Col xxl={2} lg={2}>
        <select
          className="form-control select2 mb-3 mb-xxl-0"
          defaultValue="Select Project"
          onChange={e => handleSelectProject(e.target)}
        >
          
          <option value="">Select Project</option>
          {(projectList || []).map(item => (
            <option key={item.id} value={item.project_id}>
              {item.project_name}
            </option>
          ))}
        </select>
      </Col>
      <Col xxl={2} lg={2}>
        <select
          className="form-control select2 mb-3 mb-xxl-0"
          defaultValue="Select Company"
          onChange={e => handleSelectCompany(e.target)}
        >
          <option value="">Select Company</option>
          {(billingCompanyList || []).map(item => (
            <option key={item.id} value={item.company_id}>
              {item.name}
            </option>
          ))}
        </select>
      </Col>
      <Col xxl={3} lg={3}>
        <select
          className="form-control select2 mb-3 mb-xxl-0"
          defaultValue="Select Company"
          onChange={e => handleSelectCompanyLocation(e.target)}
        >
          <option value="">Select Company Location</option>
          {(locationList || []).map(item => (
            <option key={item.id} value={item.location_id}>
              {item.location_title}
            </option>
          ))}
        </select>
      </Col>
      <Col xxl={2} lg={2}>
        <select
          className="form-control select2 mb-3 mb-xxl-0"
          defaultValue="Select Customer"
          onChange={e => handleSelectCustomer(e.target)}
        >
          <option value="">Select Customer</option>
          {(customerList || []).map(item => (
            <option key={item.id} value={item.customer_id}>
              {item.customer_name}
            </option>
          ))}
        </select>
      </Col>

      <Col xxl={2} lg={2}>
        <select
          className="form-control select2 mb-3 mb-xxl-0"
          defaultValue="Select Financial Year"
          onChange={e => handleFinancialYear(e.target)}
        >
           <option value="">Select Financial Year</option>
          {(financialYearList || []).map((item,index) => (
            <option key={index} value={item.financial_year}>
              {item}
            </option>
          ))}
        </select>
      </Col>
      <Col xxl={1} lg={1} className="mb-3">
        <div className="mb-3 mb-xxl-0">
          <button
            type="button"
            className="btn btn-soft-secondary w-100"
            onClick={handleSearch}
          >
            <i className="mdi mdi-filter-outline align-middle"></i> Filter
          </button>
        </div>
      </Col>
      <Col xxl={1} lg={1} className="mb-3">
        <div className="mb-3 mb-xxl-0">
          <button
            type="button"
            className="btn btn-soft-secondary w-100"
            onClick={handleExport}
          >
            {/* <i className="mdi mdi-filter-outline align-middle"></i> */}
             Export
          </button>
        </div>
      </Col>
    </React.Fragment>
  )
}

export default JobListGlobalFilter
